export const _setActId = (state, action) => {
    state.activitiesDetail.actId = action.payload;
};

export const _setDateCompleted = (state, action) => {
    state.activitiesDetail.dateCompleted = action.payload;
};

export const _setDateEarly = (state, action) => {
    state.activitiesDetail.dateEarly = action.payload;
};

export const _setDateLate = (state, action) => {
    state.activitiesDetail.dateLate = action.payload;
};

export const _setActivityType = (state, action) => {
    state.activitiesDetail.activityType = action.payload;
};

export const _setActivityWithContactType = (state, action) => {
    state.activitiesDetail.activityWithContactType = action.payload;
};

export const _setActivityWithContactName = (state, action) => {
    state.activitiesDetail.activityWithContactName = action.payload;
};

export const _setActivityByWestCareEmployee = (state, action) => {
    state.activitiesDetail.activityByWestCareEmployee = action.payload;
};

export const _setPriority = (state, action) => {
    state.activitiesDetail.priority = action.payload;
};

export const _setIs12StepQuestionAsked = (state, action) => {
    state.activitiesDetail.Is12StepQuestionAsked = action.payload;
};

export const _setIs12StepQuestionAnswered = (state, action) => {
    state.activitiesDetail.Is12StepQuestionAnswered = action.payload;
};

export const _setRecdCBPROI = (state, action) => {
    state.activitiesDetail.recdCBPROI = action.payload;
};

export const _setActivityNote = (state, action) => {
    state.activitiesDetail.activityNote = action.payload;
};
